/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import useStyles from './sheet';

// helpers
import { isSafari, isIE, isEdge, isFirefox, isOpera, isChrome, browserName } from 'lib/systemHelpers/browserHelpers';

const isKnownBrowser = [isEdge, isIE, isFirefox, isSafari, isOpera, isChrome].some((item) => item);

const NotSupported = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.logo} />
      <div className={classes.content}>
        <div className={classes.generalMessage}>
          {!isChrome && (
            <FormattedMessage
              id="notSupportedPage.generalMessage"
              values={{ browserName: isKnownBrowser ? browserName : 'Your' }}
              defaultMessage={`${browserName} browser is not supported`}
            />
          )}
          {isChrome && (
            <FormattedMessage
              id="notSupportedPage.invalidChrome.generalMessage"
              values={{ browserName: isKnownBrowser ? browserName : 'Your' }}
              defaultMessage="You are using an old version of Chrome"
            />
          )}
        </div>

        <div className={classes.imageWrapper}>
          <div className={classes.browserIcon} />
          {!isChrome && <div className={classes.crossIcon} />}
        </div>

        <div className={classes.description}>
          <div className={classes.descriptionTitle}>
            {!isChrome && (
              <>
                <FormattedMessage
                  id="notSupportedPage.description.title1"
                  defaultMessage="Unfortunately, we only support"
                />
                <div className={classes.chromeWrapper}>
                  <div className={classes.chromeIcon} />
                  <a
                    href="https://www.google.com/chrome/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.chromeLink}
                  >
                    Chrome
                  </a>
                </div>

                <FormattedMessage id="notSupportedPage.description.title2" defaultMessage="internet browser." />
              </>
            )}
            {isChrome && (
              <>
                <FormattedMessage
                  id="notSupportedPage.description.invalidChrome.title1"
                  defaultMessage="Update your Chrome browser to"
                />
                <div className={classes.chromeIcon} />
                <a
                  href="https://www.google.com/chrome/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.chromeLink}
                >
                  {`Chrome ${process.env.REACT_APP_CHROME_VALID_VERSION}.0`}
                </a>
                <FormattedMessage id="notSupportedPage.description.invalidChrome.title2" defaultMessage="or later" />
              </>
            )}
          </div>

          <div className={classes.descriptionMessage}>
            {!isChrome && (
              <FormattedMessage
                id="notSupportedPage.description.message"
                defaultMessage="We are working on adding support for other browsers in the near future."
              />
            )}
            {isChrome && (
              <FormattedMessage
                id="notSupportedPage.description.invalidChrome.message"
                defaultMessage="We are working on adding support for the older versions in the near future."
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotSupported;
